module.exports = __webpack_public_path__ + "static/media/a6lg.e87cb42e.png";